<!-- <dst-create-disclosure-actions [disabled]="false" (onSaveClick)="save()" (onCancelClick)="cancel()"></dst-create-disclosure-actions> -->
<!--<div id="overlay">-->
<!--  <ap-loading *ngIf="startLoader" id="text" class="loader-class" [colorName]="'a-primary'">-->
<!--  </ap-loading>-->
<!--</div>-->
@if (startLoader) {
  <div class="loader-overlay">
    <div class="backdrop"></div>
    <ap-loading class="loader" [loadingType]="'circular'" [indeterminate]="true" [compact]="false"></ap-loading>
  </div>
}
<dst-create-disclosure-actions [isView]="false" (onSaveClick)="save()" [disabled]="false" [displayNotification]="showDREMsg" [notifMsg]="DREMsg"
  (onCancelClick)="clear()" [hideBackBtn]="formState == 1" (onBackClick)="back(1)">
</dst-create-disclosure-actions>
<div class="form-template-wrapper" [ngClass]="showDREMsg ? 'msg-expanded' : ''">
  <!-- <div class="d-flex align-items-center justify-content-center"> -->
  @if (formState === 1) {
    <div class="template-header-wrapper container">
      <div class="row header-text">
        Does this Reorganization consist of a Name Change only?
      </div>
      <div class="name-change-actions">
        <button type="button" class="dst-name-change-btn" (click)="back(2)">
          <span class="Appkit4-icon icon-check-mark-outline"></span>
          <span>Yes</span>
        </button>
        <button type="button" class="dst-name-change-btn" (click)="back(3)">
          <span class="Appkit4-icon icon-close-outline"></span>
          <span>No</span>
        </button>
      </div>

    </div>
  }
<!-- </div> -->
@if (formState === 2) {
  <div>
    <div [formGroup]="form186">
      <dst-template-header #headerComp1 [parentFormGroup]="form186"
        [overwriteFormName]="'STATEMENT PURSUANT TO REGULATION 1.368-3 BY A CORPORATION,'"
        [extraLine]="'A PARTY TO A REORGANIZATION AND BY A SIGNIFICANT SHAREHOLDER'"
        (formOptionChanged)="onFormOptionChanged($event)" (consolGroupChanged)="OnConsolGroupChanged($event)">
      </dst-template-header>
      <div formGroupName="main">
        Pursuant to Section 1.368-3 of the Regulations, the following information is furnished:
        <ol class="section-content pb-0 mb-0">
          <li class="pl-3">
            <dst-template-leid-selector #mainLeidSelector [label]="'Please specify the LEID of the entity'"
              [labelId]="'100'" (onSelectedLEChanged)="onTargetChanged($event)" class="required-field entity-label">
            </dst-template-leid-selector>
            <!-- <div class="a-form-error error-leid" *ngIf="target === undefined">
            Please specify the Transferor
          </div> -->
          <div class="entity-details">
            <span>Entity Name:</span><span class="template-color-blue">{{!target ? '' : target.ENTITY}}</span>
          </div>
          <div class="entity-details">
            <span>EIN:</span><span class="template-color-blue">{{!target ? '' : (target.EIN ? target.EIN : 'N/A')}}</span>
          </div>

          <div class="inline-paragraphs pl-0">
            (formerly known as &nbsp;
            <div class="long-field">
              <ap-field [title]="''" [fieldId]="'a'" [hideTitleOnInput]="true" [styleClass]="'required-field'">
                    <input appkit-field [(ngModel)]="TransfereeName" [ngModelOptions]="{standalone: true}"
                  (focusout)="onTransfereeNameChanged()"  aria-label="A" />
                </ap-field>
              </div>
              &nbsp;)
            </div>
            <!-- <div class="a-form-error align-fields" *ngIf="TransfereeName === ''">
            Please enter the formerly known as name
          </div> -->
        </li>
        <li class="pl-3">
          <div class="inline-paragraphs-fields sec368-reorg-line">
            <span>On</span>
            <div class="inline-date-picker">
              @if (nameChangeChecked) {
                <app-date-picker-with-clear

                  [minDate]="beginDate"
                  [maxDate]="endDate"
                  [datePickerClass]="'required-field'"
                  [required]="true"
                  (dateChange)="dateChange($event, 1)"
                  (datePickerClick)="onDPOpen()"
                  (clearClick)="clearDate(1)"
                  [(ngModel)]="EffectiveDate"
                  [ngModelOptions]="{standalone: true}">
                </app-date-picker-with-clear>
              }
            </div>
            <!-- <div class="a-form-error" *ngIf="EffectiveDate === ''">
            Please select the date from a calendar
          </div> -->
          <div class="long-field sec368-name-field">
            <ap-field [title]="''" [fieldId]="'dspTransfereeName'" [hideTitleOnInput]="true" [styleClass]="'required-field'">
                    <input appkit-field [(ngModel)]="dspTransfereeName" [ngModelOptions]="{standalone: true}"  aria-label="Dsp transferee name" />
            </ap-field>
            <span class="Appkit4-icon icon-information-fill sec368-info-icon" ap-tooltip [tooltipContent]="template1" [direction]="'right'"
            [tooltipId]="'sec368-transferee-info'" ariaDescribedby="sec368-transferee-info"></span>
          </div>
          <span class="sec368-reorg-tail">
            converted to a
            <span class="short-field sec368-type-field">
              <ap-field [title]="''" [fieldId]="'additionaltext'" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="additionaltext" [ngModelOptions]="{standalone: true}"  aria-label="Additionaltext" />
              </ap-field>
            </span>
            and changed its name to <span class="template-color-blue">{{!target ? '' : target.ENTITY}}</span>, in a reorganization which qualifies under Internal Revenue Code Section 368(a)(1)(F), as a mere change in identity, form or place of organization.
          </span>
        </div>
      </li>
      <li class="pl-3">
        Records regarding the name change are maintained by the taxpayer as required under Treasury Regulation
        Section 1.368-3(d) and are available upon request.
      </li>
      <li class="pl-3 mb-0">The date and control number of any private letter ruling(s) issued by the Internal Revenue Service in
        connection with this reorganization
        <div class="inline-paragraphs-fields sec368-plr-line">
          <div class="inline-date-picker">
            <app-date-picker-with-clear
              [minDate]="beginDate"
              [maxDate]="endDate"
              [datePickerClass]="''"
              [required]="false"
              (dateChange)="dateChange($event, 2)"
              (datePickerClick)="onDPOpen()"
              (clearClick)="clearDate(2)"
              [(ngModel)]="LiquidationDate1"
              [ngModelOptions]="{standalone: true}">
            </app-date-picker-with-clear>
          </div>
          <div class="short-field sec368-plr-field">
            <ap-field [fieldId]="'401'" [title]="''" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="PLR" [ngModelOptions]="{standalone: true}"  aria-label="401" />
            </ap-field>
          </div>
        </div>
      </li>
    </ol>
    <div class="d-flex">
      <span>LEIDs: </span>
      <div>
        @if (target) {
          <span class="template-color-blue">{{ target.LEID }}</span>
        }
      </div>
    </div>
  </div>
</div>
</div>
}
@if (formState === 3) {
  <div>
    <div [formGroup]="form186Two">
      <dst-template-header #headerComp2 [parentFormGroup]="form186"
        [overwriteFormName]="'STATEMENT PURSUANT TO REGULATION 1.368-3 BY A CORPORATION,'"
        [extraLine]="'A PARTY TO A REORGANIZATION AND BY A SIGNIFICANT SHAREHOLDER'"
        (formOptionChanged)="onFormOptionChanged($event)" (consolGroupChanged)="OnConsolGroupChanged($event)">
      </dst-template-header>
      <div formGroupName="main">
        Pursuant to Section 1.368-3 of the Regulations, the following information is furnished:
        <ol class="section-content pb-0 mb-0">
          <li class="pl-3 sec368-form3-item">
            <dst-template-leid-selector #mainLeidSelector [label]="'Please specify the LEID of the entity'"
              [labelId]="'100'" (onSelectedLEChanged)="onTargetChanged($event)" class="required-field entity-label">
            </dst-template-leid-selector>
            <div class="sec368-statement-body">
              <div class="inline-paragraphs-fields sec368-on-line">
                <span>On</span>
                <div class="inline-date-picker">
                  @if (nameChangeChecked) {
                    <app-date-picker-with-clear
                      [minDate]="beginDate"
                      [maxDate]="endDate"
                      [datePickerClass]="'required-field'"
                      [required]="true"
                      (dateChange)="dateChange($event, 1)"
                      (datePickerClick)="onDPOpen()"
                      (clearClick)="clearDate(1)"
                      [(ngModel)]="EffectiveDate"
                      [ngModelOptions]="{standalone: true}">
                    </app-date-picker-with-clear>
                  }
                </div>
                <span class="template-color-blue sec368-entity-inline">{{target ? leidEntity : ''}}@if (target) {
                  ,
                }</span>
                <span class="sec368-ein-label">EIN</span>
                <span class="template-color-blue sec368-ein-value">{{target ? (leidEIN ? leidEIN : 'N/A') : ''}}</span>
              </div>
              <div class="inline-paragraphs sec368-desc-line">
                <div class="long-field name-change-desc-inline">
                  <ap-field [title]="''" [fieldId]="'nameChangeDesc'" [hideTitleOnInput]="true"
                    [styleClass]="'required-field name-change-desc'">
                    <textarea appkit-field [(ngModel)]="NameChangeDesc" [ngModelOptions]="{standalone: true}" rows="2" aria-label="Name change desc"></textarea>
                  </ap-field>
                </div>
                <span class="sec368-desc-suffix">
                  in a reorganization which qualifies under Internal Revenue Code Section 368(a)(1)(F), as a mere change in
                  identity, form or place of organization.
                </span>
              </div>
              <p class="sec368-records-text">
                Records regarding the change are maintained by the taxpayer as required under Treasury Regulation Section
                1.368-3(d) and are available upon request.
              </p>
              <p class="sec368-plr-intro mb-0">
                The date and control number of any private letter ruling(s) issued by the Internal Revenue Service in
                connection with this reorganization
              </p>
              <div class="inline-paragraphs-fields sec368-plr-line">
                <div class="inline-date-picker">
                  <app-date-picker-with-clear
                    [minDate]="beginDate"
                    [maxDate]="endDate"
                    [datePickerClass]="''"
                    [required]="false"
                    (dateChange)="dateChange($event, 2)"
                    (datePickerClick)="onDPOpen()"
                    (clearClick)="clearDate(2)"
                    [(ngModel)]="LiquidationDate1"
                    [ngModelOptions]="{standalone: true}">
                  </app-date-picker-with-clear>
                </div>
                <div class="short-field sec368-plr-field">
                  <ap-field [fieldId]="'401'" [title]="''" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="PLR" [ngModelOptions]="{standalone: true}"  aria-label="401" />
                  </ap-field>
                </div>
              </div>
            </div>
          </li>
        </ol>
        <div class="d-flex">
          <span>LEIDs: </span>
          <div>
            @if (target) {
              <span class="template-color-blue">{{ target.LEID }}</span>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
}
</div>
<ng-template #template1>
  <div class="tooltip-inner ap-p-spacing-6 d-block a-min-width-340">
    <div class="a-h6 a-text-7d7 font-weight-normal text-left ap-mt-spacing-3">
      If there was no legal entity type conversion under local law, this textbox does not need to be completed and the
      disclosure will not mention an entity type conversion.
    </div>
  </div>
</ng-template>
